import { Headset as HeadsetIcon } from 'lucide-react';
import React from 'react';

export default function Headset(): React.JSX.Element {
  return (
    <div className="relative size-full" data-name="Headset">
      <HeadsetIcon 
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        size={20}
        style={{
          color: 'var(--fill-0, #212121)'
        }}
      />
    </div>
  );
}
